export const ARIA_ROLES = Object.freeze({
  TAB_PANEL: 'tabpanel',
  BUTTON: 'button',
});
